export const goBackError = 'goBackError';
